import type { BoxProps } from "@mui/material/Box"
import type { Breakpoint } from "@mui/material/styles"
import type { ContainerProps } from "@mui/material/Container"

import { useSettingsStore } from "@/src/store"

import Box from "@mui/material/Box"
import { useTheme } from "@mui/material/styles"
import Container from "@mui/material/Container"

import { layoutClasses } from "src/layouts/classes"
// ----------------------------------------------------------------------

type MainProps = BoxProps & {
    isNavHorizontal: boolean
}

export function Main({ children, isNavHorizontal, sx, ...other }: MainProps) {
    return (
        <Box
            component="main"
            className={layoutClasses.main}
            sx={{
                display: "flex",
                flex: "1 1 auto",
                flexDirection: "column",
                ...(isNavHorizontal && {
                    "--layout-dashboard-content-pt": "40px",
                }),
                backgroundColor: "#F4F5F7",
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    )
}

// ----------------------------------------------------------------------

type DashboardContentProps = ContainerProps & {
    disablePadding?: boolean
}

export function DashboardContent({ sx, children, disablePadding, maxWidth = "xl", ...other }: DashboardContentProps) {
    const theme = useTheme()

    const compactLayout = useSettingsStore((state) => state.settings.compactLayout)

    const layoutQuery: Breakpoint = "lg"

    return (
        <Container
            className={layoutClasses.content}
            maxWidth={compactLayout ? maxWidth : false}
            sx={{
                display: "flex",
                flex: "1 1 auto",
                flexDirection: "column",
                pb: "var(--layout-dashboard-content-pb)",
                [theme.breakpoints.up(layoutQuery)]: {
                    px: "var(--layout-dashboard-content-px)",
                },
                backgroundColor: "#F4F5F7",
                ...(disablePadding && {
                    p: {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0,
                        xl: 0,
                    },
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Container>
    )
}
